import React, { Component } from 'react'
import Modal from 'react-modal';
import { connectModal } from 'redux-modal'
import { ACTION_FAIL_DIALOG } from '../../../constants'

class ActionFailDialog extends Component {

    constructor () {
        super();

        this.handleCancel = this.handleCancel.bind(this);
    }

    handleCancel () {
        this.props.handleHide();
    }


    render() {
        const { show, handleHide, message, cancelLbl } = this.props;

        return (
            <Modal
                isOpen={show}
                overlayClassName="dialog__overlay"
                className="dialog__content"
                onRequestClose={handleHide}
                role="dialog"
                ariaHideApp={true}
                contentLabel={message}
            >
                <div className="dialog--action-fail">
                    <div className="dialog__message dialog__message--fail"
                         dangerouslySetInnerHTML={{__html: message}}></div>
                    <button className="dialog__btn dialog__btn--close" onClick={this.handleCancel}
                            aria-label={cancelLbl}>X</button>
                </div>
            </Modal>
        );
    }
}

export default connectModal({ name: ACTION_FAIL_DIALOG, destroyOnHide: true })(ActionFailDialog)